import { render, staticRenderFns } from "./exerciseStatisticList.vue?vue&type=template&id=da900d82"
import script from "./exerciseStatisticList.vue?vue&type=script&lang=js"
export * from "./exerciseStatisticList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports